const basicColors = {
    white: "#ffffff",
    black: "#000000",
};
const coreColors = {
    "maven-blue-dark": "#259AC5",
    "maven-blue-bright": "#2EABD8",
    "positive-bg": "#E8FDEE",
    "positive-secondary": "#42BE65",
    "positive-primary": "#24A148",
    "negative-bg": "#FFF1F1",
    "negative-secondary": "#FF8389",
    "negative-primary": "#FA4D56",
    "warning-bg": "#FFF2E8",
    "warning-secondary": "#FF8630",
    "warning-primary": "#FB7211",
};
const greyColors = {
    grey010: "#F8F9FB",
    grey020: "#F0F2F4",
    grey025: "#DFE2E5",
    grey030: "#C1C7CD",
    grey040: "#A2A9B0",
    grey050: "#878D96",
    grey060: "#697077",
    grey070: "#4D5358",
    grey080: "#343A3F",
    grey090: "#21272A",
    grey100: "#121619",
};
const blueColors = {
    blue010: "#F0FAFF",
    blue015: "#DEF4FF",
    blue020: "#B2E5FF",
    blue030: "#88D6F4",
    blue040: "#44B8E2",
    blue050: "#259AC5",
    blue060: "#0B86B2",
    blue070: "#00759F",
    blue080: "#035D7E",
    blue090: "#004B67",
    blue100: "#00394E",
};
const darkNaviColors = {
    darkNavy005: "#EFF6FF",
    darkNavy010: "#E7F1FF",
    darkNavy020: "#B9E1FF",
    darkNavy030: "#61B8FB",
    darkNavy040: "#0D7BDC",
    darkNavy050: "#004AA7",
    darkNavy060: "#003E8B",
    darkNavy070: "#003270",
    darkNavy080: "#002554",
};
const greenColors = {
    green010: "#E8FDEE",
    green015: "#DEFBE6",
    green020: "#A7F0BA",
    green030: "#6FDC8C",
    green040: "#42BE65",
    green050: "#24A148",
    green060: "#198038",
    green070: "#0E6027",
    green080: "#044317",
    green090: "#022D0D",
};
const redColors = {
    red010: "#FFF1F1",
    red015: "#FFE3E3",
    red020: "#FFD7D9",
    red030: "#FFB3B8",
    red040: "#FF8389",
    red050: "#FA4D56",
    red060: "#DA1E28",
    red070: "#A2191F",
    red080: "#750E13",
};
const orangeColors = {
    orange010: "#FFF2E8",
    orange015: "#FFE9D9",
    orange020: "#FFD9BE",
    orange030: "#FFB784",
    orange040: "#FF8630",
    orange050: "#FB7211",
    orange060: "#DB5C00",
    orange070: "#8A3800",
    orange080: "#5E2900",
    orange090: "#3E1A00",
};
const yellowColors = {
    yellow010: "#FFFBDA",
    yellow015: "#FFF8C1",
    yellow020: "#FFF3B3",
    yellow030: "#FFEC86",
    yellow040: "#FFCD19",
    yellow050: "#FDBA00",
    yellow060: "#DDA200",
    yellow070: "#B47E1D",
    yellow080: "#82541F",
    yellow090: "#643D24",
};
const purpleColors = {
    purple010: "#F6F2FF",
    purple015: "#EDE4FF",
    purple020: "#E8DAFF",
    purple030: "#D4BBFF",
    purple040: "#BE95FF",
    purple050: "#A56EFF",
    purple060: "#8A3FFC",
    purple070: "#6929C4",
    purple080: "#491D8B",
    purple090: "#31135E",
};
const semanticColors = {
    bg010: "#F8F9FB",
    bg020: "#F4F6F9",
    bg030: "#EDF2F7",
    bg040: "#E5EBF2",
    bg050: "#D3DCE7",
    linkText: "#0D7BDC",
    dimmed010: "rgba(13, 24, 32, 0.20)",
    dimmed020: "rgba(13, 24, 32, 0.50)",
    dimmed030: "rgba(13, 24, 32, 0.70)",
};
export const semanticChartColors = {
    chartNone: "#CAD9E7",
    chartProgress010: "#8DD8FF",
    chartProgress020: "#51BEFF",
    chartProgress030: "#0094FF",
    chartProgress040: "#0068C8",
    chartProgress050: "#1F3F5E",
    chartHigh: "#FF8A00",
    chartHighest: "#FF1066",
};
export const palette = {
    ...basicColors,
    ...coreColors,
    ...greyColors,
    ...blueColors,
    ...darkNaviColors,
    ...greenColors,
    ...redColors,
    ...orangeColors,
    ...yellowColors,
    ...purpleColors,
    ...semanticColors,
    ...semanticChartColors,
};
//# sourceMappingURL=palette.js.map